<script lang="ts">
  import type { Product, ProductLine } from "@shared/types/ProductLine";
  import { soldInUnits, soldInCases } from "@shared/svelte/ProductHelpers";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import SfPricesStore from "@retailer/svelte/stores/SfPricesStore";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";

  import { canCalculateOunces, pricePerOunce } from "@retailer/services/unit_calculation_service";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  export let product: Product;
  export let productLine: ProductLine;

  const displayPricePerOunce = stagedRolloutCheck("display_price_per_ounce");

  let oneBottleListPrice, caseLevelListPrice;

  $: inventoryItemSoldBy = $InventoryItemStore?.inventoryItems[product.inventory_id]?.sold_by;
  $: {
    const listPrices = $SfPricesStore.getListPricesForInventory(product.inventory_id);

    oneBottleListPrice = listPrices.find(price => price.bottles === 1);
    caseLevelListPrice =
      listPrices.find(price => price.bottles === product.container_case_size) || oneBottleListPrice;
  }

  let inUnits, inCases;

  $: {
    inUnits = soldInUnits(product, productLine, inventoryItemSoldBy);
    inCases = soldInCases(product, productLine, inventoryItemSoldBy);
  }
</script>

{#if oneBottleListPrice}
  <div class="fizz-text-medium fizz-text-subdued" data-testid="list-price">
    List price:
    {#if inUnits && inCases}
      <FormatMoney input={oneBottleListPrice.list_price_per_unit} />/{product.container_type}
      {#if canCalculateOunces(product) && displayPricePerOunce}(${pricePerOunce(
          product,
          oneBottleListPrice.list_price_per_unit,
        )}/oz){/if} - <FormatMoney input={caseLevelListPrice.list_price_per_case} />/case {#if canCalculateOunces(product, true) && displayPricePerOunce}(${pricePerOunce(
          product,
          oneBottleListPrice.list_price_per_case,
          true,
        )}/oz){/if}
    {:else if inCases}
      <FormatMoney input={caseLevelListPrice.list_price_per_case} />/case {#if canCalculateOunces(product, true) && displayPricePerOunce}(${pricePerOunce(
          product,
          oneBottleListPrice.list_price_per_case,
          true,
        )}/oz){/if}
    {:else}
      <FormatMoney input={oneBottleListPrice.list_price_per_unit} />/{product.container_type}
      {#if canCalculateOunces(product) && displayPricePerOunce}(${pricePerOunce(
          product,
          oneBottleListPrice.list_price_per_unit,
        )}/oz){/if}
    {/if}
  </div>
{/if}
